<template>
  <main class="min-h-screen f-col">
    <transition name="fade">
      <customs-toolkit
        v-if="customsFlow"
        class="fixed-0 z-overlay"
        :customs-flow="customsFlow"
        :model
        @close-iframe="customsFlow = null"
      />
    </transition>
    <customs-header back-route="/customize" />
    <section class="grow bg-grey-90">
      <base-grid class="mt-8 container" :cols="{ sm: 1, md: 2, lg: 3 }" gap="lg">
        <div
          v-for="({ name, src, description, basePrice, upgradePrice, to }, key) in models"
          :key
          class="relative f-col rounded bg-white p-4 text-center"
        >
          <h2 v-html="name" class="title-3 uppercase" style="padding-inline: 4rem" />
          <div>
            <base-picture height="122" :src width="193" />
          </div>
          <div v-html="description" class="grow content-center py-8 text-center text-sm" />
          <vf-button class="w-full" :to>
            <span class="absolute-0 z-1" />
            {{ getPriceString(basePrice, upgradePrice) }}
          </vf-button>
        </div>
      </base-grid>
    </section>
  </main>
</template>

<script lang="ts" setup>
definePageMeta({ layout: false })
const { $t } = useNuxtApp()

const { data, error } = await useApi().internal.getStaticPage('customs-models')
if (!data.value) throw createError({ ...error.value!, fatal: true })

const { model } = useRoute().params
const customsFlow = useRouteQuery('customsFlow')
const models = data.value[`${model}`]

const getPriceString = (basePrice, upgradePrice) => {
  const priceList = (upgradePrice || basePrice).split('-')
  const formattedPrice = priceList.map((price) => useFormattedPrice(+price, useCurrencyCode())).join('-')

  return upgradePrice
    ? `${$t.customs.upgrade} + ${formattedPrice}`
    : formattedPrice
}
</script>
